import React, { Fragment } from 'react'

import { ImageMediaClient } from './ImageMedia/index.client'
import { VideoMedia } from './VideoMedia'

import type { Props } from './types'

export const Media: React.FC<Props> = (props) => {
  const { className, htmlelement = 'div', resource } = props

  if (resource === undefined || resource === null) return <></>

  const isVideo = typeof resource === 'object' && resource?.mimeType?.includes('video')
  const Tag = htmlelement || Fragment

  return (
    <Tag
      {...(htmlelement !== null
        ? {
            className,
          }
        : {})}
    >
      {isVideo ? <VideoMedia {...props} /> : <ImageMediaClient resource={resource} {...props} />}
    </Tag>
  )
}
